import { type LabelLayoutSettingsValues } from "./types"

export const defaultLabelSettings: LabelLayoutSettingsValues = {
  // Label dimensions
  columns: 1, // number of columns
  columnGap: 0, //mm
  labelWidth: 50, // mm
  labelHeight: 25, // mm

  // Spacing
  marginTop: 0, // mm
  marginBottom: 0, // mm
  marginLeft: 0, // mm
  marginRight: 0, // mm
  padding: 1.5, // mm

  // QR Code settings
  qrCodeSize: 25, // mm
  qrCodeMarginRight: 3, // mm
  qrCodeAlignment: "left", // left, center, right

  // Text settings
  productNameFontSize: 10, // px
  batchNumberFontSize: 10, // px
  expiryFontSize: 7, // px
  textAlignment: "left", // left, center, right
  productNameWrap: "multi", // single or multi
  productNameMaxLines: 2, // max lines when multi-line

  // Zoom/Scale
  zoom: 1.0, // 100%

  // Orientation
  orientation: "landscape" // landscape or portrait,
}

export const getDefaultLabelSettings = (): LabelLayoutSettingsValues => {
  return { ...defaultLabelSettings }
}

export const orientationOptions = [
  { value: "landscape", label: "Landscape" },
  { value: "portrait", label: "Portrait" }
]

export const alignmentOptions = [
  { value: "left", label: "Left" },
  { value: "center", label: "Center" },
  { value: "right", label: "Right" }
]

export const nameWrapOptions = [
  { value: "single", label: "Single Line" },
  { value: "multi", label: "Multi Line" }
]
